import { cmsAxios } from "./config/axiosConfig";

export const fetchNewUsersReport = async (
  startDate: string,
  endDate: string
) => {
  try {
    const response = await cmsAxios.get("/cms/reports/new-users", {
      params: { startDate, endDate },
    });
    return response?.data;
  } catch (error) {
    console.error("Error fetching new users report:", error);
    return null;
  }
};

export const fetchTotalUsersReport = async () => {
  try {
    const response = await cmsAxios.get("/cms/reports/total-users");
    return response?.data;
  } catch (error) {
    console.error("Error fetching total users report:", error);
    return null;
  }
};

export const fetchCategoriesReport = async (
  startDate: string,
  endDate: string,
  libraryid: string | null
) => {
  try {
    // ✅ Build query params dynamically
    let url = `/cms/reports/categories?startDate='${startDate}'&endDate='${endDate}'`;
    if (libraryid === null) {
      url += `&libraryId=${libraryid}`;
    } else {
      url += `&libraryId='${libraryid}'`;
    }

    const response = await cmsAxios.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching categories report:", error);
    return null;
  }
};

export const fetchProctorReports = async (
  startDate: string,
  endDate: string
) => {
  try {
    const response = await cmsAxios.get(
      `/cms/reports/proctors?startDate='${startDate}'&endDate='${endDate}'`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching proctor reports:", error);
    return null;
  }
};
